<template>
  <div class="footer-page-container">
    <div class="page-content">
      <h1 class="page-title">网站地图</h1>
      <div class="page-body">
        <section class="sitemap-intro">
          <h2>网站地图</h2>
          <p>网站地图展示了本网站的主要页面结构，帮助您快速找到所需内容。</p>
        </section>
        
        <section class="sitemap-structure" style="margin-top: 30px;">
          <h2>网站结构</h2>
          
          <h3>1. 首页</h3>
          <ul class="sitemap-list">
            <li><a href="/" style="color: #3E2CCD; text-decoration: underline;">首页</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">2. 学习</h3>
          <ul class="sitemap-list">
            <li><a href="/study" style="color: #3E2CCD; text-decoration: underline;">学习中心</a></li>
            <li><a href="/learn/:id" style="color: #3E2CCD; text-decoration: underline;">课程学习</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">3. 考试</h3>
          <ul class="sitemap-list">
            <li><a href="/exam" style="color: #3E2CCD; text-decoration: underline;">考试中心</a></li>
            <li><a href="/exam-detail/:id" style="color: #3E2CCD; text-decoration: underline;">模拟试卷详情</a></li>
            <li><a href="/exam-intro/:id" style="color: #3E2CCD; text-decoration: underline;">考试说明</a></li>
            <li><a href="/exam-submit-result" style="color: #3E2CCD; text-decoration: underline;">考试结果</a></li>
            <li><a href="/practice-detail/:id" style="color: #3E2CCD; text-decoration: underline;">练习试卷详情</a></li>
            <li><a href="/error-notes" style="color: #3E2CCD; text-decoration: underline;">错题记录</a></li>
            <li><a href="/my-exams" style="color: #3E2CCD; text-decoration: underline;">我的考试</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">4. 课程</h3>
          <ul class="sitemap-list">
            <li><a href="/course/:id" style="color: #3E2CCD; text-decoration: underline;">课程详情</a></li>
            <li><a href="/course-purchase/:id" style="color: #3E2CCD; text-decoration: underline;">课程购买</a></li>
            <li><a href="/payment/:id" style="color: #3E2CCD; text-decoration: underline;">支付页面</a></li>
            <li><a href="/study-machine-purchase/:id" style="color: #3E2CCD; text-decoration: underline;">学习机购买</a></li>
            <li><a href="/project-detail/:id" style="color: #3E2CCD; text-decoration: underline;">项目详情</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">5. 会员中心</h3>
          <ul class="sitemap-list">
            <li><a href="/member-center" style="color: #3E2CCD; text-decoration: underline;">会员中心</a></li>
            <li><a href="/member-center/courses" style="color: #3E2CCD; text-decoration: underline;">我的课程</a></li>
            <li><a href="/member-center/exams" style="color: #3E2CCD; text-decoration: underline;">我的考试</a></li>
            <li><a href="/member-center/error-notes" style="color: #3E2CCD; text-decoration: underline;">错题记录</a></li>
            <li><a href="/member-center/coupons" style="color: #3E2CCD; text-decoration: underline;">优惠券</a></li>
            <li><a href="/member-center/orders" style="color: #3E2CCD; text-decoration: underline;">我的订单</a></li>
            <li><a href="/member-center/address" style="color: #3E2CCD; text-decoration: underline;">地址管理</a></li>
            <li><a href="/member-center/simulation" style="color: #3E2CCD; text-decoration: underline;">模拟练习</a></li>
            <li><a href="/member-center/messages" style="color: #3E2CCD; text-decoration: underline;">站内信</a></li>
            <li><a href="/member-center/settings" style="color: #3E2CCD; text-decoration: underline;">个人设置</a></li>
            <li><a href="/member-center/projects" style="color: #3E2CCD; text-decoration: underline;">我的项目</a></li>
            <li><a href="/member-center/collections" style="color: #3E2CCD; text-decoration: underline;">我的收藏</a></li>
            <li><a href="/member-center/distribution-rights" style="color: #3E2CCD; text-decoration: underline;">分销权益</a></li>
            <li><a href="/member-center/order/:id" style="color: #3E2CCD; text-decoration: underline;">订单详情</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">6. 购物车</h3>
          <ul class="sitemap-list">
            <li><a href="/cart" style="color: #3E2CCD; text-decoration: underline;">购物车</a></li>
          </ul>
          
          <h3 style="margin-top: 20px;">7. 关于我们</h3>
          <ul class="sitemap-list">
            <li><a href="/about-us" style="color: #3E2CCD; text-decoration: underline;">关于我们</a></li>
            <li><a href="/about-talent-plan" style="color: #3E2CCD; text-decoration: underline;">关于英才计划</a></li>
            <li><a href="/company-qualification" style="color: #3E2CCD; text-decoration: underline;">企业资质</a></li>
            <li><a href="/legal-statement" style="color: #3E2CCD; text-decoration: underline;">法律声明</a></li>
            <li><a href="/copyright-statement" style="color: #3E2CCD; text-decoration: underline;">版权声明</a></li>
            <li><a href="/disclaimer" style="color: #3E2CCD; text-decoration: underline;">免责条款</a></li>
            <li><a href="/social-responsibility" style="color: #3E2CCD; text-decoration: underline;">社会责任</a></li>
            <li><a href="/market-cooperation" style="color: #3E2CCD; text-decoration: underline;">市场合作</a></li>
            <li><a href="/privacy-policy" style="color: #3E2CCD; text-decoration: underline;">隐私政策</a></li>
            <li><a href="/user-agreement" style="color: #3E2CCD; text-decoration: underline;">用户协议</a></li>
            <li><a href="/help-center" style="color: #3E2CCD; text-decoration: underline;">帮助中心</a></li>
            <li><a href="/sitemap" style="color: #3E2CCD; text-decoration: underline;">网站地图</a></li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSitemap',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="scss">
.footer-page-container {
  max-width: 1200px;
  margin: 100px auto 0;
  padding: 40px 20px;
}

.page-content {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #3E2CCD;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.page-body {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  
  p {
    margin-bottom: 15px;
  }
}
</style>
